import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { DealTableFilterSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/deal/_list/')({
  validateSearch: zodValidator(DealTableFilterSchema)
});